import { render } from "./PricesPage.vue?vue&type=template&id=163016fa&ts=true"
import script from "./PricesPage.vue?vue&type=script&lang=ts"
export * from "./PricesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__